import React from 'react';

const anchors = [
  'PRO-ZD801',
  'SGV-2020',
  'EFB-PCTH',
  'IRC-150',
  'HTW-111',
  '送貨須知',
  '產品保養須知',
  '條款及細則',
];

export const useScrollUpdateHash = () => {
  React.useEffect(() => {
    window.addEventListener('scroll', () => {
      const anchorElements = anchors.map((_) => document.getElementById(_));
      const anchorOffsetTops = anchorElements.map(
        (_) => (_?.offsetTop ?? 0) + (_?.offsetHeight ?? 0) - (20 ?? 0),
      );

      const index = anchorOffsetTops.findIndex(
        (top) => window.scrollY < (top || 0),
      );

      if (
        window.scrollY < (anchorElements[0]?.offsetTop ?? 0) - 50 ||
        !anchors[index]
      ) {
        window.history.pushState(
          null,
          '',
          window.location.pathname + window.location.search,
        );

        return;
      }

      if (anchors[index] !== window.location.hash.slice(1)) {
        window.history.pushState(null, '', `#${anchors[index]}`);
      }
    });
  }, []);
};
